import request from '../../../components/api/api';
import {
    fetchedOverviewAccommodations,
    fetchedOverviewDates,
    fetchedOverviewRequirements,
    fetchedProducts,
    fetchedSnippetAttributeOptions,
} from './actions';
import {ROOT_URL} from '../../../config';

export function fetchOverviewDates(siteId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/overview-dates?site_id=${siteId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedOverviewDates(response.data))
        );
    };
}

export function fetchProducts() {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/products`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedProducts(response.data))
        );
    };
}

export function fetchActiveProductsBySiteId(siteId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/products?active=true&site_id=${siteId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedProducts(response.data))
        );
    };
}

export function fetchOverviewAccommodations(siteId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/overview-accommodations?site_id=${siteId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedOverviewAccommodations(response.data))
        );
    };
}

export function fetchOverviewRequirements(siteId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/overview-requirements?site_id=${siteId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedOverviewRequirements(response.data))
        );
    };
}

export function fetchSnippetAttributeOptions() {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/snippets/attribute-options`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedSnippetAttributeOptions(response.data))
        );
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/meta/thunks.js